import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
    },
    radius: {
      flexShrink: 0,
    },
    label: {
      paddingBottom: "6px",
    },
    inputContainer: {
      display: "flex",
      alignItems: "baseline",

      "& > *": {
        marginRight: theme.hv.spacing.xs,
      },
    },
    input: {
      width: 90,
    },

    location: {
      marginTop: 22,
      flexGrow: 1,
    },

    button: {
      marginTop: 22,
      marginLeft: 10,
      minWidth: 110,
    },
  };
});
